var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-account bc-white"},[_c('Filter_monentreprise'),_c('div',{staticClass:"main"},[_c('Subcontent_'+_vm.$store.state.ui.monentreprise_subcontent,{tag:"component"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }